import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import authService from "../Services/authService";
import { PlayCircle, ChevronRight } from "lucide-react";

const STATUS_LABEL = {
  waiting: "You have a game waiting to start",
  playing: "You have a game in progress",
};

const ResumeRoomBanner = () => {
  const [room, setRoom] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const loadActiveRoom = async () => {
      try {
        const userRooms = await authService.getUserRooms();

        const roomsWithStatus = await Promise.all(
          userRooms.slice(0, 8).map(async (r) => {
            try {
              const roomQuery = query(collection(db, "rooms"), where("roomId", "==", r.roomId));
              const roomSnapshot = await getDocs(roomQuery);
              if (!roomSnapshot.empty) {
                const data = roomSnapshot.docs[0].data();
                return {
                  ...r,
                  currentStatus: data.gameStatus || "waiting",
                  isActive: true,
                  isDeleted: false,
                };
              }
              return { ...r, currentStatus: "deleted", isActive: false, isDeleted: true };
            } catch {
              return { ...r, currentStatus: "unknown", isActive: false, isDeleted: false };
            }
          })
        );

        const activeRooms = roomsWithStatus.filter(
          (r) => r.isActive && !r.isDeleted && r.currentStatus !== "ended"
        );

        setRoom(activeRooms[0] || null);
      } catch {
        setRoom(null);
      }
    };
    loadActiveRoom();
  }, []);

  if (!room) return null;

  const joinRoom = () => {
    localStorage.setItem("currentRoomId", room.roomId);
    navigate("/create-room");
  };

  return (
    <button
      onClick={joinRoom}
      className="w-full flex items-center bg-red-50 border-2 border-red-200 rounded-xl px-4 py-3 mb-4 hover:bg-red-100 active:scale-[0.99] transition-all text-left"
    >
      <PlayCircle className="w-6 h-6 text-red-600 shrink-0 mr-3" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-bold text-red-700 truncate">
          Resume "{room.roomName}"
        </p>
        <p className="text-xs text-gray-500">
          {STATUS_LABEL[room.currentStatus] || "You have a game in progress"}
        </p>
      </div>
      <div className="flex items-center text-red-600 font-semibold text-sm shrink-0 ml-2">
        Resume
        <ChevronRight className="w-4 h-4 ml-0.5" />
      </div>
    </button>
  );
};

export default ResumeRoomBanner;
